import { FC, useMemo } from 'react';
import { Modal, Table } from '../../../components';
import { useMediaQuery, Fade, Divider, Typography, Box } from '@mui/material';
import { IOrderDetailStatus } from '../../../models';
import { formatShortFriendlyDateWithTime } from '../../../helpers';
import { MobileStatus } from './mobile-status-history';
import { theme } from '../../../styles/theme';

interface IStatusHistoryModal {
  open: boolean;
  onClose: () => void;
  statuses: IOrderDetailStatus[];
}

export const StatusHistoryModal: FC<IStatusHistoryModal> = ({ onClose, open, statuses }) => {
  const isMobile = useMediaQuery('(max-width: 960px)');
  const columns = useMemo(() => {
    return [
      {
        Header: 'Date/Time',
        accessor: 'createdDateTime',
        sort: false,
        Cell: ({
          cell: {
            row: { original }
          }
        }: {
          cell: { row: { original: IOrderDetailStatus } };
        }) => {
          return <>{formatShortFriendlyDateWithTime(original.createdDateTime)}</>;
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        sort: false,
        Cell: ({
          cell: {
            row: { original }
          }
        }: {
          cell: { row: { original: IOrderDetailStatus } };
        }) => {
          return <Box color={original.status === 'Remediating' ? theme.palette.error.main : '#000'}>{original.status}</Box>;
        }
      },
      {
        Header: 'Comments',
        accessor: 'comment',
        sort: false
      },
      {
        Header: 'Created By',
        accessor: 'createdBy',
        sort: false
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statuses]);
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
      }}
      maxWidth="md"
    >
      <Fade in={open}>
        <div>
          <Box marginBottom="8px">
            <Typography variant="h5">Status History</Typography>
          </Box>
          <Divider />
          <Box marginTop="1rem">
            <Table
              columns={columns}
              data={
                statuses
                  ? statuses.sort(function (a, b) {
                      // sort the values by date with the most recent at the top of the table
                      return new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime();
                    })
                  : []
              }
              hidePagination
              ResponsiveComponent={isMobile ? MobileStatus : undefined}
              noResultsText="No Status History Found"
            />
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};
